import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import StaffDt from '@/services/dataTransferModules/staffDt'
import { getEmployeeTitle } from '@/helpers/entities/staff/staffHelpers'

export default function useStaff(params = {}) {
	const staffDt = new StaffDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingStaff: {
			name: '',
			icon_file_id: '',
			working: true,
			phone: '',
			telegram_id: '',
			email: '',
			groups: null,
			description: '',
			official_number: '',
			dob: null,
			entity: '',
			position: '',
			in_state: '',
			start_work_date: null,
			department: null,
			personnel_number: '',
			passport: '',
			end_work_date: null,
		},
		fieldsToPatch: [
			'name',
			'icon_file_id',
			'working',
			'phone',
			'telegram_id',
			'email',
			'groups',
			'description',
			'official_number',
			'dob',
			'entity',
			'position',
			'in_state',
			'start_work_date',
			'department',
			'personnel_number',
			'passport',
			'end_work_date',
		],
	}

	const {
		selectedCompanyId,
		showUiErrorNotification,

		loadEntityFlags: flags,

		entities: fullStaff,
		getEntities: getFulledStaff,

		extendedEntities: extendedStaff,
		getExtendedEntities: getExtendedStaff,

		basedEntities: baseStaff,
		getBasedEntities: getBasedStaff,

		hashedBasedEntities: hashedBasedStaff,
		getHashedBasedEntities: getHashedBasedStaff,

		createEntity: createStaff,

		entity: staff,
		getEntity: getStaff,

		entityPopup: staffPopup,
		getEntityPopup: getStaffPopup,

		entityPreview: staffPreview,
		getEntityPreview: getStaffPreview,

		patchEntity: updateStaff,
		updateEntity: fullUpdateStaff,

		deleteEntity: deleteStaff,
	} = useBlProviders(
		staffDt,
		Object.assign(
			{
				postProcessEntityCallback: (employee) => {
					employee.__ao__title = getEmployeeTitle(employee)
					return employee
				},

				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Employee loading error'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Couldn`t add a new staff. Please contact technical support team.'),

				showErrorNotificationForLoadingOneEntity: true,
				errorNotificationTextForLoadingOneEntity: $t('Failed to load data. Contact technical support team.'),

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Couldn`t edit a staff. Please contact technical support team.'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Couldn`t remove. Please contact technical support team.'),
			},
			params,
		),
	)

	const staffWithRelatedUserId = ref([])

	const getStaffWithRelatedUser = async () => {
		staffWithRelatedUserId.value = (await getFulledStaff()).filter((item) => !!item.related_user)

		return staffWithRelatedUserId.value
	}

	const setStaffPermission = (staffId, body) => {
		return new Promise((resolve, reject) => {
			flags.isUpdating = true

			staffDt
				.setPermissions(selectedCompanyId.value, staffId, body)
				.then((res) => {
					flags.isUpdating = false
					resolve(res)
				})
				.catch(() => {
					flags.isUpdating = false

					showUiErrorNotification({
						timeout: 3000,
						text: $t('Error!'),
					})
					reject()
				})
		})
	}

	return {
		flags,
		fullStaff,
		baseStaff,
		staffWithRelatedUserId,
		extendedStaff,
		staffPreview,
		staffPopup,
		staff,
		defaults,
		getBasedStaff,
		getStaffWithRelatedUser,
		getExtendedStaff,
		getFulledStaff,
		getStaffPreview,
		getStaffPopup,
		getStaff,
		createStaff,
		updateStaff,
		fullUpdateStaff,
		setStaffPermission,
		deleteStaff,

		hashedBasedStaff,
		getHashedBasedStaff,
	}
}
